import $ from 'jquery';
import { Component } from '../core/component';

export class MobileNav extends Component {
    constructor() {
        super();
        this.selector = '.navigation--mobile';
    }

    init() {
        /* eslint-disable no-unused-vars */
        this.$elements.each((index, element) => {
            const menuTriggerClassName = 'navigation-main__menu-trigger-wrapper';
            const menuClassName = 'navigation-main__menu';
            const $mobileMenuTrigger = $(`.${menuTriggerClassName}`);
            const $mobileMenuContainer = $(`.${menuClassName}`);

            $mobileMenuTrigger.click(function () {
                if ($(this).hasClass(`${menuTriggerClassName}--active`)) {
                    $(this).removeClass(`${menuTriggerClassName}--active`);
                    $mobileMenuContainer.removeClass(`${menuClassName}--active`);
                    $('body').removeClass('nav-menu-open');
                } else {
                    $(this).addClass(`${menuTriggerClassName}--active`);
                    $mobileMenuContainer.addClass(`${menuClassName}--active`);
                    $('body').addClass('nav-menu-open');
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/mobileNav.js